import { render, staticRenderFns } from "./disb.vue?vue&type=template&id=29bbecfd&scoped=true"
import script from "./disb.vue?vue&type=script&lang=js"
export * from "./disb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbecfd",
  null
  
)

export default component.exports